/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_404_CtaInputs */

const en_cmp_404_cta = /** @type {(inputs: Cmp_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Bystep`)
};

const id_cmp_404_cta = /** @type {(inputs: Cmp_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke Bystep`)
};

/**
* | output |
* | --- |
* | "Back to Bystep" |
*
* @param {Cmp_404_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_404_cta = /** @type {((inputs?: Cmp_404_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_404_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_404_cta(inputs)
	return en_cmp_404_cta(inputs)
});